module.exports = __webpack_public_path__ + "static/media/pointer.3df9ec78.png";